import { Component, ElementRef, EventEmitter, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DataViewer } from '../../../abstract/DataViewer';
import { MainComponent } from '../../../pages/main/main.component';
import { BeNeo4jService } from '../../../services/be-neo4j.service';
import { SharedService } from '../../../services/shared.service';
import { ShapeBounding } from '../../../clases/ShapeBounding';
import { Exporter } from '../../../clases/Exporter';
import { CanvasRenderer } from '../../../abstract/CanvasRenderer';
import { NotifyDialogService } from '../../../services/notify-dialog.service';
import { MatIcon, MatIconRegistry } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CenterCanvasComponent } from '../../buttons/center-canvas/center-canvas.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TabType } from '../../../enums/TabType';
import { ServerResponseObject } from '../../../interfaces/ServerResponse';
import { AllMetricsTypes } from '../../../interfaces/MetricType';
import { DomSanitizer } from '@angular/platform-browser';
import { DataViewActionsComponent } from '../data-view-actions/data-view-actions.component';

@Component({
  selector: 'view-visualizer',
  standalone: true,
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatIcon,
    MatButtonModule,
    CenterCanvasComponent,
    MatTooltipModule,
    DataViewActionsComponent
  ],
  providers: [{ provide: DataViewer, useExisting: ViewVisualizerComponent }],
  templateUrl: './view-visualizer.component.html',
  styleUrl: './view-visualizer.component.scss'
})

export class ViewVisualizerComponent extends CanvasRenderer {
  constructor(
    protected override beNeo4jService: BeNeo4jService,
    protected override sharedService: SharedService,
    private notifyDialogService: NotifyDialogService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) 
  {
    super(beNeo4jService, sharedService); 
     this.iconRegistry.addSvgIcon(
      'custom_timeline',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/sidebar_icons/timeline.svg')
    );
  }

  viewCreator: ViewVisualizerComponent = this;

  @ViewChild('canvas', { static: true })
  set canvasRef(value: ElementRef<HTMLCanvasElement>) {
    let canvas: HTMLCanvasElement = value.nativeElement;
    this.canvas = canvas;
    this._canvasBounding = new ShapeBounding(0, 0, canvas.width, canvas.height);
  }

  @Input()
  override set appComponent(value: MainComponent) {
    this._appComponent = value;
  }

  override get appComponent(): MainComponent {
    return this._appComponent;
  }

  @Input()
  set containerElement(value: HTMLElement) {
    this._containerElement = value;
  }

  get containerElement(): HTMLElement {
    return this._containerElement;
  }

  override onMouseMove(e: MouseEvent) {
    this.isShapeHover = this.canvasHelper.onHoverShape(e, this.canvasItems, this.hoveredShape);
    this.isConnectionHover = this.canvasHelper.onHoverConnection(e, this.connections, this.hoveredConnection);
    this.canvasHelper.paneCamera(e);
    this.draw();
  }


  override onMouseUp() {
    this.checkFocus();
    this.canvasHelper.stopCameraPanning();
    this.draw();
  }

  ngAfterViewInit(): void {
    this._isViewEditable = false;
    setTimeout(() => {
      this.setupCanvas();
      this.bindEvents();
    }, 0)
    
    document.addEventListener('contextmenu', (event) => {
      event.preventDefault();
    });
  }

  protected override errorReporting(title: string, message: string): void {
    this.notifyDialogService.openDialog(title, message);
  }
  protected override afterFetchingContent(): void {
    super.afterFetchingContent();
    if(this.savedDocument.model_UUID)this.showMetricsButton = true;
  }
}
